<template>
  <div :style="{ 'width': this.$store.state.clientWidth + 'px' }">
    <van-tabs v-model="active" swipeable animated>
      <van-tab title="未使用">
        <div class="coupon-list">
          <img v-for="(item, index) in unused" :key="index" @click="goToDetail(item)" :src="item | filterCouponCover" />
        </div>
      </van-tab>
      <van-tab title="已使用">
        <div class="coupon-list">
          <img v-for="(item, index) in used" :key="index" @click="goToDetail(item)" :src="item | filterCouponCover" />
        </div>
      </van-tab>
      <van-tab title="已过期">
        <div class="coupon-list">
          <img v-for="(item, index) in expired" :key="index" @click="goToDetail(item)" :src="item | filterCouponCover" />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { filterPicture } from '@/filters'

export default {
  data () {
    return {
      active: 0,
      used: [],
      unused: [],
      expired: [],
    }
  },

  filters: {
    filterCouponCover (row) {
      if (row.type === 'PRIZE') return filterPicture(row.livePrizeDetail.imageList)
      else if (row.type === 'VOUCHER' && row.liveVoucherDetail) return filterPicture(row.liveVoucherDetail.imageList)
      else return filterPicture(row.goodsDetail.imageList)
    }
  },

  activated () {
    this.toast.loading({ duration: 0, message: '', forbidClick: true })
    this.used = []
    this.unused = []
    this.expired = []
    
    this.request({ 
      url: '/liveReceive/list',
      data: { liveRoomId: this.$store.state.room.id, limit: 100 },
    }).then(res => {
      this.toast.clear()
      res.result.rows.map(item => {
        if (item.status === 'UESD') this.used.push(item)
        else if (item.status === 'UNUSED') this.unused.push(item)
        else if (item.status === 'INVALID') this.expired.push(item)
      })
    })
  },

  methods: {
    goToDetail (row) {
      if (row.goodsDetail) {
        this.$router.push({ path: '/coupon-product/' + row.id })
      } else {
        this.$router.push({ path: '/coupon/' + row.id })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-list {
  padding: 20px 15px;
  min-height: calc(100vh - 44px);
  padding-bottom: calc(3.5rem * .5625 + .8rem);
  img {
    margin-bottom: 12px;
    width: 100%;
  }
}
</style>